import { render, staticRenderFns } from "./HeaderContent.vue?vue&type=template&id=1d56d8a2&scoped=true"
import script from "./HeaderContent.vue?vue&type=script&lang=js"
export * from "./HeaderContent.vue?vue&type=script&lang=js"
import style0 from "./HeaderContent.vue?vue&type=style&index=0&id=1d56d8a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d56d8a2",
  null
  
)

export default component.exports